// img 태그에서 src 로드 중일 때 Skeleton UI를 보여주기 위한 store
import { create } from 'zustand';

interface BeautyFilterImageState {
  loadingImages: Set<string>;
  loadedImages: Set<string>;

  startLoadingImage: (imageSrc: string) => void;
  endLoadingImage: (imageSrc: string) => void;
}

const useBeautyFilterImageStore = create<BeautyFilterImageState>((set, get) => ({
  loadingImages: new Set(),
  loadedImages: new Set(),

  startLoadingImage: (imageSrc: string) => {
    const { loadingImages, loadedImages } = get();

    if (!imageSrc) return;
    if (loadingImages.has(imageSrc) || loadedImages.has(imageSrc)) return;
    loadingImages.add(imageSrc);
    set({
      loadingImages: new Set(loadingImages),
    });
  },

  endLoadingImage: (imageSrc: string) => {
    const { loadingImages, loadedImages } = get();
    loadingImages.delete(imageSrc);
    loadedImages.add(imageSrc);
    set({
      loadingImages: new Set(loadingImages),
      loadedImages: new Set(loadedImages),
    });
  },
}));

export default useBeautyFilterImageStore;
